// extracted by mini-css-extract-plugin
export default {"leftline":"index_leftline_lLHrU","rightline":"index_rightline_dIhq7","dividertext":"index_dividertext_36wXl","divider":"index_divider_mOedk"};